export const API_PATH_ApiAppOptionsPut = '/services/app/apiAppOptionsPut';
